<template>
	<v-row v-if="loaded">
		<!-- <v-col
			v-if="column.attribute === 'include_data' || column.attribute === 'receive_information' || column.attribute === 'data_to_third_parties'"
		>
			<v-checkbox class="ml-0" v-model="internalModel" :label="$t(column.attribute)" :true-value="true" :false-value="false"></v-checkbox>
		</v-col> -->
		<v-col style="padding: 0rem; margin-top: 1rem;" v-if="column.attribute === 'person_treatment'">
			<fv-select
				v-model="internalModel"
				:required="column.mandatory"
				:items="personTreatment"
				:label="$t(column.attribute)"
				itemValue="visitreatment"
				itemText="text"
				clearable
			/>
		</v-col>

		<v-col v-else-if="column.attribute === 'person_document_type'">
			<fv-select
				v-model="internalModel"
				:required="column.mandatory"
				:items="docTypes"
				:label="$t(column.attribute)"
				itemValue="code"
				itemText="text"
				clearable
			/>
		</v-col>

		<v-col v-else-if="column.attribute === 'person_sex'">
			<fv-select
				v-model="internalModel"
				:required="column.mandatory"
				:items="personSex"
				:label="$t(column.attribute)"
				itemValue="visisex"
				itemText="text"
				clearable
			/>
		</v-col>
		<v-col v-else-if="column.attribute === 'person_country'">
			<fv-select
				v-model="internalModel"
				:required="column.mandatory"
				:items="countries"
				:label="$t(column.attribute)"
				itemValue="counisocode"
				itemText="cotrname"
				clearable
				@change="handleCountry"
				ref="person_country"
			/>
		</v-col>
		<v-col v-else-if="column.attribute === 'person_province'">
			<fv-select
				v-model="internalModel"
				:required="column.mandatory"
				:items="provinces"
				:label="$t(column.attribute)"
				itemValue="provcode"
				itemText="prtrname"
				clearable
				@change="handleProvince"
				ref="person_province"
			/>
		</v-col>

		<v-col v-else-if="column.attribute === 'person_email'">
			<fv-text-field
				v-model="internalModel"
				:maxlength="column.length"
				:required="column.mandatory"
				:label="$t(column.attribute)"
				:rules="emailRules"
				@keyup="lowercase"
			/>
		</v-col>

		<v-col v-else-if="column.attribute !== 'include_data' && column.attribute !== 'receive_information' && column.attribute !== 'data_to_third_parties'">
			<fv-text-field v-model="internalModel" :maxlength="column.length" :required="column.mandatory" :label="$t(column.attribute)" />
		</v-col>
	</v-row>
</template>

<script>
import api from '../../../api/api';
import FvTextField from '@/components/general/FvTextField.vue';
import FvSelect from '@/components/general/FvSelect.vue';
export default {
	components: { FvTextField, FvSelect },
	name: 'headercomponentgenerator',
	props: {
		column: {
			type: Object
		},
		indexColumn: {
			type: Number
		},
		userData: {
			type: Object
		}
	},
	data() {
		return {
			personTreatment: [
				{ visitreatment: 'sr', text: this.$t('headercomponentgenerator.sr') },
				{ visitreatment: 'sra', text: this.$t('headercomponentgenerator.sra') },
				{ visitreatment: 'srta', text: this.$t('headercomponentgenerator.srta') }
			],
			docTypes: [
				{ code: 'NIF', text: this.$t('headercomponentgenerator.nif') },
				{ code: 'NIE', text: this.$t('headercomponentgenerator.nie') },
				{ code: 'PASSPORT', text: this.$t('headercomponentgenerator.passport') }
			],
			personSex: [
				{ visisex: 'H', text: this.$t('headercomponentgenerator.hombre') },
				{ visisex: 'M', text: this.$t('headercomponentgenerator.mujer') }
			],
			emailRules: [(v) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || this.$t('exception.notvalidemail')],
			countries: [],
			provinces: [],
			loaded: false
		};
	},
	created() {
		this.column.attribute === 'person_country' && this.allCountries();
		this.column.attribute === 'person_province' && this.allProvinces();
		this.loaded = true;
	},
	mounted() {
		if (this.userData.email) {
			this.setValue(this.column.attribute);
		}
	},
	computed: {
		internalModel: {
			get() {
				return this.column.value;
			},
			set(newValue) {
				this.column.value = newValue;
				this.$emit('newValue', newValue);
			}
		}
	},
	methods: {
		allCountries() {
			const params = { lang: this.$i18n.locale };
			return api.country
				.getAll({ params })
				.then((response) => {
					this.countries = response.data.sort((a, b) => {
						const order = { 'España': 1, 'Espanya': 2, 'Spain': 3 };
						return (order[a.cotrname] || Number.MAX_SAFE_INTEGER) - (order[b.cotrname] || Number.MAX_SAFE_INTEGER);
					});
				})
				.catch((err) => {
					console.log(err);
				});
		},
		allProvinces() {
			const params = {
				country: 'ES',
				lang: this.$i18n.locale
			};
			return api.province
				.getAll({ params })
				.then((response) => {
					this.provinces = response.data;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		setValue(attribute) {
			if (attribute === 'include_data') {
				if (this.userData.visiincludedata === 1) {
					this.internalModel = true;
				} else {
					this.internalModel = false;
				}
			} else if (attribute === 'receive_information') {
				if (this.userData.visireceiveinformation === 1) {
					this.internalModel = true;
				} else {
					this.internalModel = false;
				}
			} else if (attribute === 'data_to_third_parties') {
				if (this.userData.visidatathirdparties === 1) {
					this.internalModel = true;
				} else {
					this.internalModel = false;
				}
			} else if (attribute === 'person_treatment') {
				this.internalModel = this.userData.visitreatment;
				this.refreshTreatment++;
			} else if (attribute === 'person_name') {
				this.internalModel = this.userData.name;
				console.log('person_name', this.internalModel);
			} else if (attribute === 'person_surname') {
				this.internalModel = this.userData.usfvsurname;
			} else if (attribute === 'person_document_type') {
				this.internalModel = this.userData.usfvdocumenttype;
				this.refreshDocument++;
			} else if (attribute === 'person_document') {
				this.internalModel = this.userData.usfvdocument;
			} else if (attribute === 'person_sex') {
				this.internalModel = this.userData.visisex;
				this.refreshSex++;
			} else if (attribute === 'person_country') {
				this.internalModel = this.userData.usfvcountry;
				this.refreshCountry++;
			} else if (attribute === 'person_province') {
				this.internalModel = this.userData.usfvprovince;
				this.refreshProvince++;
			} else if (attribute === 'person_city') {
				this.internalModel = this.userData.usfvcity;
			} else if (attribute === 'person_postal_code') {
				this.internalModel = this.userData.usfvcp;
			} else if (attribute === 'person_address1') {
				this.internalModel = this.userData.usfvaddress1;
			} else if (attribute === 'person_address2') {
				this.internalModel = this.userData.usfvaddress2;
			} else if (attribute === 'person_email') {
				this.internalModel = this.userData.usr;
			} else if (attribute === 'person_mobile') {
				this.internalModel = this.userData.visimobile;
			} else if (attribute === 'person_phone') {
				this.internalModel = this.userData.usfvphone;
			} else if (attribute === 'person_twitter') {
				this.internalModel = this.userData.visitwitter;
			} else if (attribute === 'person_facebook') {
				this.internalModel = this.userData.visifacebook;
			} else if (attribute === 'person_instagram') {
				this.internalModel = this.userData.visiinstagram;
			} else if (attribute === 'person_linkedin') {
				this.internalModel = this.userData.visilinkedin;
			} else if (attribute === 'company_razon_social') {
				this.internalModel = this.userData.companyData.viconame;
			} else if (attribute === 'company_cenae') {
				this.internalModel = this.userData.companyData.vicocenae;
			} else if (attribute === 'company_web') {
				this.internalModel = this.userData.companyData.vicoweb;
			} else if (attribute === 'company_vol_compra') {
				this.internalModel = this.userData.companyData.vicovolumencompra;
			} else if (attribute === 'company_vol_venta') {
				this.internalModel = this.userData.companyData.vicovolumenventa;
			} else if (attribute === 'company_beneficio_neto') {
				this.internalModel = this.userData.companyData.vicobeneficioneto;
			} else if (attribute === 'company_riesgo_comercial') {
				this.internalModel = this.userData.companyData.vicoriesgocomercial;
			}
		},
		lowercase() {
			this.internalModel = this.internalModel.toLowerCase();
		},
		handleCountry() {
            let country;
			for (let index = 0; index < this.$parent.$children.length; index++) {
				if(this.$parent.$children[index].$refs["person_country"]) {
					country = (this.$parent.$children[index]);
				}
			}

			let province;
			for (let index = 0; index < this.$parent.$children.length; index++) {
				if(this.$parent.$children[index].$refs["person_province"]) {
					province = (this.$parent.$children[index]);
				}
			}
			// if(province != null) {
			// 	province.internalModel = null;
			// }

            if (country.internalModel != 'ES') {
                if (province !== undefined) {
                    province.internalModel = '-';
                }
            } else {
                if (province !== undefined) {
                    province.internalModel = null;
                }
            }

				// country.internalModel = 'ES';


		},
		handleProvince() {
			let country;
			for (let index = 0; index < this.$parent.$children.length; index++) {
				if(this.$parent.$children[index].$refs["person_country"]) {
					country = (this.$parent.$children[index]);
				}
			}

            let province;
			for (let index = 0; index < this.$parent.$children.length; index++) {
				if(this.$parent.$children[index].$refs["person_province"]) {
					province = (this.$parent.$children[index]);
				}
			}

			// if(country != null) {
                if(province.internalModel === '-') {
                    if (country !== undefined) {
                        country.internalModel = null;
                    }
                } else {
                    if (country !== undefined) {
                        country.internalModel = 'ES';
                    }
                }

				// country.internalModel = 'ES';
			// }


		}
	},
	watch: {
		// 'internalModel': {
		// 	handler(newValue) {
		// 		console.log('ha seteado', newValue);
		// 		this.$emit('newValue', newValue);
		// 	},
		// 	// force eager callback execution
		// 	immediate: true
		// }
	}
};
</script>

<style></style>
